import React from 'react';
import RugbyLeagueBackground from '../../../rugbyLeague/demoBackground.jpg';
import FootballBackground from '../../../football/demoBackground.jpg';
import RugbyUnionBackground from '../../../rugbyUnion/demoBackground.jpg';
import camelCase from 'camelcase';
const sportDemoBackgrounds = {
    football: FootballBackground,
    rugbyLeague: RugbyLeagueBackground,
    rugbyUnion: RugbyUnionBackground
};
export const Background = ({ overlay, sport, width, height }) => {
    if (overlay.background === 'demo') {
        return (React.createElement("div", { style: { position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, width, height, zIndex: -5000 } },
            React.createElement("img", { width: `${width}`, height: `${height}`, src: sportDemoBackgrounds[camelCase(sport)] })));
    }
    if (overlay.background === 'color') {
        return (React.createElement("div", { style: {
                position: 'absolute',
                background: overlay.backgroundColor,
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                width: '100%',
                height: '100%',
                zIndex: -2147483647
            } }));
    }
    return null;
};
//# sourceMappingURL=index.js.map